import React from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';
import DeliveryDiffBadge from 'components/itr-items-table/DeliveryDiffBadge';

const DeliveryDiffBadgeForView = (props) => (
  <CWOConfigProvider>
    <DeliveryDiffBadge {...props} />
  </CWOConfigProvider>
);

export default DeliveryDiffBadgeForView;
